import colorSharp2 from "../assets/img/color-sharp2.png";
import { skills } from "../data/portfolioData";

export const Skills = () => {
  const skillByName = skills.reduce((lookup, skill) => {
    lookup[skill.name] = skill;
    return lookup;
  }, {});

  const getInitials = (name) =>
    name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();

  const darkLogoInLightTheme = new Set(["GitHub", "Vercel", "Debugging", "Framer"]);

  const groups = [
    {
      title: "Frontend",
      subtitle: "Modern interfaces and reusable UI components.",
      tone: "frontend",
      items: [
        { name: "React" },
        { name: "Angular" },
        { name: "JavaScript" },
        { name: "TypeScript" },
        { name: "HTML5" },
        { name: "CSS" },
        { name: "TailwindCSS" },
        { name: "Bootstrap" },
        { name: "Next.js" },
      ],
    },
    {
      title: "Design & Motion",
      subtitle: "Design workflows and polished interactions.",
      tone: "design",
      items: [
        { name: "Figma" },
        { name: "Adobe XD" },
        { name: "Photoshop" },
        { name: "Illustrator" },
        { name: "Framer" },
        { name: "GSAP" },
        { name: "Canva" },
        { name: "WordPress" },
        { name: "UI/UX" },
      ],
    },
    {
      title: "Tools & Platforms",
      subtitle: "Tooling for build, deploy, and collaboration.",
      tone: "tools",
      items: [
        { name: "Vite" },
        { name: "Git" },
        { name: "GitHub" },
        { name: "Vercel" },
        { name: "Netlify" },
      ],
    },
    {
      title: "Programming",
      subtitle: "Core languages and problem-solving foundations.",
      tone: "foundation",
      items: [
        { name: "C" },
        { name: "C++" },
        { name: "Python" },
        { name: "Data Structures" },
        { name: "Debugging" },
      ],
    },
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx">
              <div className="skills-header">
                <p className="skills-kicker">Technical Stack</p>
                <h2>Tech Stack & Tools</h2>
                <p className="skill-text">
                  Skills and technologies I use to design and build modern web
                  experiences.
                </p>
              </div>
              <div className="skills-bento-grid">
                {groups.map((group) => (
                  <article
                    className={`skills-card skills-card-${group.tone}`}
                    key={group.title}
                  >
                    <h3>{group.title}</h3>
                    <p>{group.subtitle}</p>
                    <div className="skills-chip-wrap">
                      {group.items.map((item) => (
                        <div className="skills-chip" key={item.name}>
                          {skillByName[item.name]?.image ? (
                            <img
                              className={darkLogoInLightTheme.has(item.name) ? "skill-logo-dark-on-light" : ""}
                              src={skillByName[item.name].image}
                              alt={item.name}
                              loading="lazy"
                              decoding="async"
                            />
                          ) : (
                            <span className="skills-chip-fallback" aria-hidden="true">
                              {getInitials(item.name)}
                            </span>
                          )}
                          <h4>{item.name}</h4>
                        </div>
                      ))}
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-top-right" src={colorSharp2} alt="Background" loading="lazy" decoding="async" />
    </section>
  );
};
